<template>
    <div class="EnumerationManagement" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <div class="Left">
            <el-input v-model="input" placeholder="请输入内容"></el-input>
            <!-- <el-button type="primary" @click="OpenUpdata">新增</el-button> -->
            <div :style="{height: Height - 220 + 'px'}" class="ListData">
                <ul>
                    <li v-for="item in query(input)" :key="item.id" :class="(item.PK_EY_Enum === PK_EY_Enum)?'PointBGC': ''" @click="Point(item)">
                        <span>{{item.cName}}</span>
                        <div class='flod'>
                            <!-- <i class="el-icon-edit" v-show="(item.PK_EY_Enum === PK_EY_Enum)" @click="EditData(item)"></i>
                            <i class="el-icon-circle-close" v-show="(item.PK_EY_Enum === PK_EY_Enum)" @click="remove(item)"></i> -->
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="Right">
            <el-row>
                <el-col>
                    <h3>枚举管理</h3>
                </el-col>
                <el-col :span="12"></el-col>
                <el-col :span="12">
                    <el-button type="primary" @click="OpenUpdatas">新增</el-button>
                    <el-button type="primary" @click="OpenUpdatasS">批量新增</el-button>
                </el-col>
            </el-row>
            <el-table :data="radioData" border style="width: 100%" :height="Height - 260 + 'px'">
                <el-table-column prop="cName" label="枚举名称">
                </el-table-column>
                <el-table-column prop="address" label="操作" width="200px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="EditDatas(scope.row)">编辑</el-button>
                        <el-button type="text" @click="removes(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div>
                <h3>枚举内容</h3>
                <el-button type="primary" @click="OpenUpdatas">新增</el-button>
                <el-button type="primary" @click="OpenUpdatasS">批量新增</el-button>
                <div class="listBox" :style="{height: Height - 250 + 'px'}">
                <draggable tag="ul" v-model="radioData"
                    @change="change"
                    @start="start"
                    @end="end">
                    <li style="height: 30px;" v-for="item in radioData" :key="item.id" :class="(item.PK_EY_Enums === PK_EY_Enums)?'PointBGC': ''" @click="Points(item)">
                        <span>{{item.cName}}</span>
                        <div class='flod'>
                            <i class="el-icon-edit" v-show="(item.PK_EY_Enums === PK_EY_Enums)" @click="EditDatas(item)"></i>
                            <i class="el-icon-circle-close" v-show="(item.PK_EY_Enums === PK_EY_Enums)" @click="removes(item)"></i>
                        </div>
                    </li>
                </draggable>
                </div>
            </div> -->
        </div>
        <el-dialog :title="!edit?'新增字段':'修改字段'" width="30%" :visible.sync="dialogFormVisible">
            <el-form @submit.native.prevent>
                <el-input v-model="name" autocomplete="off"></el-input>
                <!-- <el-form-item label="活动名称" :label-width="formLabelWidth">
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button v-if="!edit" type="primary" @click="NewDataSubUPdata" @keyup.enter.native="NewDataSubUPdataEnter">保存并新增</el-button>
                <el-button type="primary" @click="NewDataSub">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="!edits?'新增字段':'修改字段'" width="30%" :visible.sync="dialogFormVisibleLeft">
            <el-form @submit.native.prevent>
                <el-form-item label="枚举内容" :label-width="formLabelWidth">
                <el-input v-model="names" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleLeft = false">取 消</el-button>
                <el-button v-if="!edits" type="primary" @click="NewSaveUPdata" @keyup.enter.native="NewDataSubUPdataEnter">保存并新增</el-button>
                <el-button type="primary" @click="NewDataSubs">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="!edits?'批量新增字段':'修改字段'" width="30%" :visible.sync="dialogFormVisibleLeftS">
            <el-form @submit.native.prevent>
                <el-form-item label="枚举内容" :label-width="formLabelWidth">
                <span class="zhu">注：关键字使用‘,’区分</span>
                <el-input type="textarea" resize='none' :rows="8" placeholder="请输入内容" v-model="textarea" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleLeftS = false">取 消</el-button>
                <el-button v-if="!edits" type="primary" @click="NewSaveUPdataS" @keyup.enter.native="NewDataSubUPdataEnter">保存并新增</el-button>
                <el-button type="primary" @click="NewDataSubsS">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import draggable from "vuedraggable";
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "EnumerationManagement",
    data () {
        return {
            fullscreenLoading: false,
            data: [],
            radio: '',
            input: '',
            PK_EY_Enum: '',
            PK_EY_Enums: '',
            radioData: [],
            NewData: '',
            dialogFormVisible: false,
            dialogFormVisibleLeft: false,
            dialogFormVisibleLeftS: false,
            formLabelWidth: '60',
            name: '',
            names: '',
            edit: false,
            edits: false,
            iorder: '',
            enumpk: '',
            textarea: ''
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        change (e) {
            for (let i = 0; i < this.radioData.length; i++) {
                this.radioData[i].iOrder = i
            }
            let data = {
                data: JSON.stringify(this.radioData),
                PK_EY_Enum: this.enumpk
            }
            this.$store.dispatch('SortEnum', data)
        },
        start (e) {
        },
        end (e) {
        },
        GetTreeData () {
            let data = {
            }
            this.$store.dispatch('GetTreeData', data).then((res) => {
                this.data = res.data
            })
        },
        GetTreeDataItem (e) {
            this.enumpk = e
            let data = {
                PK_EY_Enum: e
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.radioData = res.data
            })
        },
        Point (e) {
            this.PK_EY_Enum = e.PK_EY_Enum
            this.GetTreeDataItem(e.PK_EY_Enum)
        },
        OpenUpdata () {
            this.dialogFormVisible = true
            this.edit = false
            this.name = ''
            this.NewDataSubUPdataEnter()
        },
        EditData (e) {
            this.name = e.cName
            this.dialogFormVisible = true
            this.edit = true
            this.NewDataSubUPdataEnter()
        },
        NewDataSub () {
            if (this.name !== '') {
                let data = {}
                if (!this.edit) {
                    data = {
                        cName: this.name
                    }
                    this.$store.dispatch('SaveData', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.dialogFormVisible = false
                    })
                } else {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        cName: this.name
                    }
                    this.$store.dispatch('SaveData', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.dialogFormVisible = false
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '内容不能为空'
                })
            }
        },
        NewDataSubUPdata () {
            if (this.name !== '') {
                let data = {}
                if (!this.edit) {
                    data = {
                        cName: this.name
                    }
                    this.$store.dispatch('SaveData', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        // this.dialogFormVisible = false
                        this.name = ''
                    })
                } else {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        cName: this.name
                    }
                    this.$store.dispatch('SaveData', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        // this.dialogFormVisible = false
                        this.name = ''
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '内容不能为空'
                })
            }
        },
        NewDataSubUPdataEnter () {
            document.onkeydown = e => {
                if (e.keyCode === 13) {
                    if (this.dialogFormVisible) {
                        this.NewDataSubUPdata()
                    } else if (this.dialogFormVisibleLeft) {
                        this.NewSaveUPdata()
                    } else if (this.dialogFormVisibleLeftS) {
                        this.NewSaveUPdataS()
                    }
                }
            }
        },
        remove (e) {
            if (this.radioData.length > 0) {
                this.$message.error('删除失败，该数据存在子项')
            } else {
                let data = {
                    PK_EY_Enum: this.PK_EY_Enum
                }
                this.$store.dispatch('Remove', data).then((res) => {
                    if (res.flag) {
                        this.$message({
                            type: 'success',
                            message: res.message
                        })
                    }
                    this.GetTreeData()
                })
            }
        },
        OpenUpdatas () {
            if (this.PK_EY_Enum !== '') {
                this.dialogFormVisibleLeft = true
                this.edits = false
                this.names = ''
                this.NewDataSubUPdataEnter()
            } else {
                this.$message({
                    type: 'warning',
                    message: '请先选择枚举类别！'
                })
            }
        },
        OpenUpdatasS () {
            if (this.PK_EY_Enum !== '') {
                this.dialogFormVisibleLeftS = true
                this.edits = false
                this.textarea = ''
                this.NewDataSubUPdataEnter()
            } else {
                this.$message({
                    type: 'warning',
                    message: '请先选择枚举类别！'
                })
            }
        },
        NewDataSubs () {
            if (this.names !== '') {
                let data = {}
                if (!this.edits) {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        cName: this.names,
                        iOrder: this.iorder
                    }
                    this.$store.dispatch('SaveDatas', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.dialogFormVisibleLeft = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                } else {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        PK_EY_Enums: this.PK_EY_Enums,
                        cName: this.names
                    }
                    this.$store.dispatch('SaveDatas', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.dialogFormVisibleLeft = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '内容不能为空'
                })
            }
        },
        NewDataSubsS () {
            if (this.textarea !== '') {
                let data = {}
                var val = this.textarea.replace(/，/ig, ',')
                this.textarea = val
                // console.log(val)
                // console.log(this.textarea)
                if (!this.edits) {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        enums: this.textarea,
                        iOrder: this.iorder
                    }
                    this.$store.dispatch('AddEnum', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.dialogFormVisibleLeftS = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                } else {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        PK_EY_Enums: this.PK_EY_Enums,
                        enums: this.textarea
                    }
                    this.$store.dispatch('AddEnum', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.dialogFormVisibleLeftS = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '内容不能为空'
                })
            }
        },
        NewSaveUPdata () {
            if (this.names !== '') {
                let data = {}
                if (!this.edits) {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        cName: this.names
                    }
                    this.$store.dispatch('SaveDatas', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.names = ''
                        // this.dialogFormVisibleLeft = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                } else {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        PK_EY_Enums: this.PK_EY_Enums,
                        cName: this.names
                    }
                    this.$store.dispatch('SaveDatas', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.names = ''
                        // this.dialogFormVisibleLeft = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '内容不能为空'
                })
            }
        },
        NewSaveUPdataS () {
            if (this.textarea !== '') {
                let data = {}
                var val = this.textarea.replace(/，/ig, ',')
                this.textarea = val
                if (!this.edits) {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        enums: this.textarea
                    }
                    this.$store.dispatch('AddEnum', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.textarea = ''
                        // this.dialogFormVisibleLeft = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                } else {
                    data = {
                        PK_EY_Enum: this.PK_EY_Enum,
                        PK_EY_Enums: this.PK_EY_Enums,
                        enums: this.textarea
                    }
                    this.$store.dispatch('AddEnum', data).then((res) => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                        }
                        this.GetTreeData()
                        this.edit = false
                        this.textarea = ''
                        // this.dialogFormVisibleLeft = false
                        this.GetTreeDataItem(this.PK_EY_Enum)
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '内容不能为空'
                })
            }
        },
        Points (e) {
            this.PK_EY_Enums = e.PK_EY_Enums
        },
        EditDatas (row) {
            this.PK_EY_Enums = row.PK_EY_Enums
            this.names = row.cName
            this.dialogFormVisibleLeft = true
            this.edits = true
        },
        removes (row) {
            this.PK_EY_Enums = row.PK_EY_Enums
            // console.log(row)
            let data = {
                PK_EY_Enum: row.PK_EY_Enum,
                PK_EY_Enums: row.PK_EY_Enums
            }
            this.$store.dispatch('Removes', data).then((res) => {
                if (res.flag) {
                    this.$message({
                        type: 'success',
                        message: res.message
                    })
                }
                this.GetTreeDataItem(row.PK_EY_Enum)
            })
        },
        query (key) {
            // 我这里直接return（也可赋给变量return变量出去）
            return this.data.filter(item => {
                // 如果list(name)包含key(输入框) => true
                if (item.cName.includes(key)) {
                // 返回item
                    return item
                }
            })
        }
    },
    created() {
        this.GetTreeData()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    },
    components: {
        draggable
    }
}
</script>

<style>
.EnumerationManagement {
    margin: 0;
    padding: 15px;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
}
.EnumerationManagement .Left {
    width: 330px;
    border: 1px solid #ededed;
    padding: 10px;
    margin-right: 15px;
    overflow: auto;
}
.EnumerationManagement .Left .ListData li {
    color: #333;
}
/* .EnumerationManagement .ListData {
  padding-top: 15px;
} */
.EnumerationManagement li {
    /* height: 30px; */
    line-height: 30px;
    padding-left: 15px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.EnumerationManagement li:hover {
    background-color: #97baef;
    cursor: pointer;
}
.EnumerationManagement .PointBGC {
    background-color:#97baef;
}
.EnumerationManagement .Right {
    width: calc(100% - 345px);
    /* height: 300px; */
    padding: 10px;
    /* border: 1px solid #ededed; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
}
.EnumerationManagement .Right h3 {
    color: #333;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
}
.EnumerationManagement .Right .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.EnumerationManagement .Right .el-row .el-col:last-child {
    text-align: right;
}
.EnumerationManagement .Right .el-table {
    margin-top: 10px;
}
.EnumerationManagement .Left li, .EnumerationManagement .Right li {
    position: relative;
    color: #333;
}
.EnumerationManagement .Right .foot {
    width: 100%;
    height: 50px;
    /* background-color: cadetblue; */
    /* text-align: right; */
}
.EnumerationManagement .Left span, .EnumerationManagement .Right span {
    width: 100%;
    /* display: inline-block; */
    word-wrap: break-word;
}
.EnumerationManagement .Left .ListData .flod, .EnumerationManagement .Right .listBox .flod {
    position: absolute;
    right: 0px;
    bottom: 0px;
}
.EnumerationManagement i {
    display: inline-block;
    margin-right: 15px;
    line-height: 30px;
}
.EnumerationManagement .dialog-footer {
    width: 100%;
}
.EnumerationManagement .zhu {
    color: red;
}
</style>
